module.exports = __webpack_public_path__ + "img/icon-show-password.387dcf85.svg";